import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from '@mui/icons-material/Pending';
import {Box, Tooltip} from "@mui/material";
import FeedbackIcon from '@mui/icons-material/Feedback';
import RemoveIcon from '@mui/icons-material/Remove';

export function authorizationStateChipLabelAndColor(state) {
    if (state === "Approved") {
        return {label: 'Aprobada', color: 'success'};
    } else if (state === "Changes Required") {
        return {label: 'Pide cambios', color: 'warning'};
    } else if (state === "Denied") {
        return {label: 'Denegada', color: 'error'};
    }
    return {label: 'Pendiente', color: 'default'};
}

export function renderAuthorizationStateIcon(params) {
    const value = params.value;
    let icon = null;
    let tooltipText = '';
    if (value === "Approved") {
        icon = <CheckCircleIcon sx={{ color: 'success.main' }} />;
        tooltipText = 'Aprobado';
    } else if (value === "Denied") {
        icon = <CancelIcon sx={{ color: 'error.main' }} />;
        tooltipText = 'Denegado';
    } else if (value === "Pending") {
        icon = <PendingIcon sx={{ color: 'text.secondary' }} />;
        tooltipText = 'Pendiente';
    } else if (value === "Changes Required") {
        icon = <FeedbackIcon sx={{ color: 'info.main' }} />;
        tooltipText = 'Cambios Pedidos';
    } else if (value === null || value === undefined) {
        icon = <RemoveIcon sx={{ color: 'text.disabled' }} />;
        tooltipText = 'No existe';
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Tooltip title={tooltipText}>
            {icon}
            </Tooltip>
        </Box>
    );
}
